<template>
    <div>
      <!-- Content -->
      <div class="container my-6 px-5">
        <div class="is-clickable column mr-2 is-flex colour-secondary-01 is-underlined bold-l2 my-5 pl-0" @click="$router.push('/consultant/my-resource-centre')">
            <b-icon
                icon="menu-left"
                custom-size="is-large"
                style="font-size: 30px;"
            ></b-icon>
          <span>Back to My Resource Centre</span>
        </div>
        <div class="columns is-12 is-mobile is-desktop mb-6 is-multiline">
          <div class="column is-9-desktop is-12-mobile has-text-left">
            <div class="video is-square">
                <iframe width="100%" height="600"
                    :src="link">
                </iframe>
            </div>
            <div class="colour-primary-02 bold-l my-4">Video</div>
            <div style="max-width: 936px;">
              <div class="pb-title mt-3 mb-5">{{ title }}</div>
              <div class="mb-6" v-html="content" />
            </div>
          </div>
        </div>

      </div>
  
      
    </div>
  </template>
  
  <script>
    import dayjs from 'dayjs';
    import Axios from 'axios'
  
    export default {
      data() {
        return {
          video: [],
          title: '',
          link: '',
          content: ''
        };
      },
      mounted() {
        window.scrollTo(0, 0);
        // this.updateContentByPage(1);
        // this.populateAllData()
        this.$httpClientCMS({
          method: 'GET',
          url:'api/my-resource-centres?populate=*&filters[category]=Video&filters[id]=' + this.$route.params.id,
        })
        .then(resp =>{
          this.video = resp.data.data[0];
          this.content = this.video.attributes.content;
          this.link  = this.video.attributes.link
          this.title   = this.video.attributes.title
        })
      },
      computed: {
    
      },
      methods:{
        downloadItem ({ url, label }) {
          Axios.get(url, { responseType: 'blob' })
            .then(response => {
              const blob = new Blob([response.data], { type: 'application/pdf' })
              const link = document.createElement('a')
              link.href = URL.createObjectURL(blob)
              link.download = label
              link.click()
              URL.revokeObjectURL(link.href)
            }).catch(console.error)
        },
      }
    }
  </script>
  
  <style scoped lang="scss">
  
  .header-wrapper {
    margin-top: 1rem;
  }
  
  .sidebar-wrapper {
    text-align: left;
    .item-sidebar {
      padding: 0.5rem 0;
      cursor: pointer;
      &.active {
        font-weight: 600;
        color: #730039;
        text-decoration: 4px underline;
        text-underline-offset: 5px;
      }
    }
  } 
  
  .section {
    padding: 3rem 0;
  }
  
  .content {
    display: block;
    width: 100%;
    min-height: 850px;
    background-color: #FFFFFF;
    padding: 2rem 5rem 3rem;
    text-align: left;
  }
  
  .tag-box {
    background-color: #37395A;
    padding: 0.5rem 1rem;
    margin-right: 0.5rem;
    margin-top: 0.5rem;
    color: #FFFFFF;
  }
  
  .topic-card {
    display: flex;
    background-color: #F3F3F3;
    padding: 1.3rem;
    padding-right: 2.5rem;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    .pb-title {
      font-size: 1.25rem;
    }
  }
  
  :deep(){
  
    .mdi-link {
      rotate: -45deg !important;
    }
    .dropdown-content {
      background-color: white;
      text-align: left;
    }
    
    @media screen and (max-width: 1023px){
      .control.has-icons-right .icon.is-right{
        height: -webkit-fill-available;
        padding-right: 20px;
      }
      
      .control.has-icons-left .input, .icon.is-left {
        border-radius: 0 !important;
        font-weight: normal;
        font-size: inherit;
        color: #dbdbdb !important;
        padding-right: 20px !important;
      }
    }
  
    @media screen and (max-width: 768px){
      .control {
        padding-left: 0;
        padding-right: 0;
      }

      
    }
  }
  
  
  @media screen and (max-width:1290px) and (min-width: 1022px){
  }
  
  @media screen and (max-width:1023px) {
    .video iframe {
      height: 450px !important;
    }

    .container {
      margin-top: 0 !important;
    }
  
  }
  
  @media screen and (max-width:893px){
  
  }

  @media screen and (max-width:768px){

    .video iframe {
      height: 335px !important;
    }

  }
  
  @media screen and (max-width:576px){

    .video iframe {
      height: 235px !important;
    }
  
  }
  </style>
  